import { render, staticRenderFns } from "./Criar.vue?vue&type=template&id=8f70a430&lang=pug"
import script from "./Criar.vue?vue&type=script&lang=js"
export * from "./Criar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports